/**
 * GTN Hero Banner - frontend swiper initialization.
 */
(function () {
	const AUTOPLAY_DELAY = 5000;
	const MANUAL_SPEED = 900;

	function initHeroSwipers() {
		if (typeof Swiper === 'undefined') {
			return;
		}

		const roots = document.querySelectorAll('[data-gtn-hero-swiper="true"]');
		if (!roots.length) {
			return;
		}

		roots.forEach((root) => {
			const container = root.querySelector('.swiper');
			const pagination = root.querySelector('.swiper-pagination');

			if (!container || container.swiper) {
				return;
			}

			new Swiper(container, {
				direction: 'vertical',
				effect: 'slide',
				speed: MANUAL_SPEED,
				grabCursor: true,
				loop: true,
				loopAdditionalSlides: 1,
				pagination: {
					el: pagination,
					clickable: true,
				},
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: false,
					sensitivity: 0.8,
					thresholdDelta: 20,
				},
				autoplay: {
					enabled: true,
					delay: AUTOPLAY_DELAY,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				allowTouchMove: true,
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHeroSwipers);
		return;
	}

	initHeroSwipers();
})();
